export const theme = {
  token: {
    colorPrimary: 'rgba(31, 31, 31, 1)',
    // 基础配色
    colorText: 'rgba(31, 31, 31, 1)',
    // 第二梯度
    colorTextSecondary: 'rgba(105, 105, 105, 1)',
    // 选中的颜色
    controlItemBgActive: '#e6f7ff',
    controlItemBgActiveHover: '#cceaff',
  },
  components: {
    Button: {
      colorPrimary: 'rgba(31, 31, 31, 1)',
      // algorithm: true
    },
    Tabs: {
      itemSelectedColor: 'rgba(31, 31, 31, 1)',
      inkBarColor: 'rgba(31, 31, 31, 1)',
      itemHoverColor: 'rgba(31, 31, 31, 1)',
    },
    Table: {
      colorTextHeading: 'rgba(105, 105, 105, 1)',
      /* 避免黑色主色衍生出深灰/黑色行 hover（全选后划过尤其明显） */
      rowHoverBg: '#f5f5f5',
      rowSelectedBg: '#e6f7ff',
      rowSelectedHoverBg: '#cceaff',
      controlItemBgHover: '#f5f5f5',
    },
    Switch: {
      // 开关选中时的颜色（蓝色）
      colorPrimary: '#1890ff',
      // 开关未选中时的颜色（灰色）
      colorBgUnchecked: '#d9d9d9',
      // 隐藏文字
      innerTextChecked: '',
      innerTextUnChecked: '',
    },
  },
};
